// FAQ page scripts

const ARROW_SVG = `<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 6.81818L7 0.818176L1 6.81818" stroke="var(--color-heading)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

function reveal(container) {
  container.style.opacity = '1';
}

function buildAccordions() {
  const container = document.querySelector('.page-content-width.rte');
  if (!container) return;

  const h3s = Array.from(container.querySelectorAll('h3'));
  if (!h3s.length) {
    reveal(container);
    return;
  }

  h3s.forEach((h3) => {
    // Collect all siblings until the next H2 or H3
    const contentNodes = [];
    let next = h3.nextElementSibling;
    while (next && next.tagName !== 'H2' && next.tagName !== 'H3') {
      contentNodes.push(next);
      next = next.nextElementSibling;
    }

    const summary = document.createElement('summary');
    summary.textContent = h3.textContent;
    const arrowSpan = document.createElement('span');
    arrowSpan.innerHTML = ARROW_SVG;
    summary.appendChild(arrowSpan);

    const contentDiv = document.createElement('div');
    contentDiv.className = 'accordion__content rte';
    contentNodes.forEach((node) => contentDiv.appendChild(node));

    const details = document.createElement('details');
    details.appendChild(summary);
    details.appendChild(contentDiv);

    const accordion = document.createElement('div');
    accordion.className = 'accordion';
    accordion.appendChild(details);

    h3.replaceWith(accordion);
  });

  reveal(container);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', buildAccordions);
} else {
  buildAccordions();
}
